


















import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
export default Vue.extend({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('program/catalog', ['form'])
  },
  watch: {
    'form.fidz.value': 'updateDefaultFidzImageUrl'
  },
  methods: {
    ...mapMutations('program/catalog', [
      'changeFidzValue',
      'updateDefaultFidzImageUrl'
    ])
  }
})
